import React, { useState } from "react";
import Modal from "./Modal";
import Button from "../Button";
import TextAreaField from "../forms/TextArea";
import { useSelector } from "react-redux";
import Icon from "../Icon";
import { useDispatch } from "react-redux";
import { reverseTransaction, getClientActivity } from "../../features/clients/clientSlice";


const ReverseTransactionModal = ({
  openReverseTransactionModal,
  setOpenReverseTransactionModal,
  transactionId,
  clientType,
  storedData,
}) => {
  const [reasonForReversal, setReasonForReversal] = useState("");
  const dispatch = useDispatch();
  const { isLoading } = useSelector((store) => store.client);

  // Add a function to handle text input with character limit
  const handleReasonChange = (e) => {
    const text = e.target.value;
    // Limit text to 200 characters
    if (text.length <= 200) {
      setReasonForReversal(text);
    }
  };

  const handleReverseTransaction = async () => {
    await dispatch(reverseTransaction({ providerActivityLogId: transactionId, reason: reasonForReversal }));
    await dispatch(
      getClientActivity({
        clientType,
        page: 0,
        numPerPage: 7,
        branch: storedData?.id,
      })
    );
    setReasonForReversal("");
    setOpenReverseTransactionModal(false);
  };

  return (
    <Modal
      handleClose={() => {
        setOpenReverseTransactionModal(false);
      }}
      title={"REVERSE TRANSACTION"}
      show={openReverseTransactionModal}
      isModalBig={false}
      containerClassName="addClients--modal"
    >
      <div className="w-full gap-[30px] flex flex-col justify-start items-start">
        <div className="w-full gap-[6px] flex flex-col justify-start items-start">
          <span className="font-[500] text-[14px] leading-[24px] text-[#344054]">
            Reason for Reversal
          </span>

          <TextAreaField
            isFloatingLabel={false}
            placeHolder={"Enter reason for reversal"}
            value={reasonForReversal}
            onChange={handleReasonChange}
            className={"mb-0"}
          />

          <span className="font-[400] leading-[18px] text-end w-full text-[#5C6368]">
            {reasonForReversal.length}/200
          </span>
        </div>

        <Button
          variant="primary"
          type="submit"
          className=""
          placeholder={"Reverse Transaction"}
          placeHolder={"Reverse Transaction"}
          block
          disabled={reasonForReversal.trim() === "" || isLoading}
          onClick={handleReverseTransaction}
        >
          {"Reverse Transaction"}
        </Button>
      </div>
    </Modal>
  );
};

export default ReverseTransactionModal;
